import { IApiError } from "../api.interfaces";
import { ICredentialsWithServer } from "../credentialsStore";
import { TNeedsLoginAndCall } from "./interfaces";
import { ReAuthStrategy } from "./reAuthStrategy";

export class ExpiredPasswordStrategy extends ReAuthStrategy {
    protected invokeReLogin(error: IApiError, credentials: ICredentialsWithServer | null, needsLoginAndCall: TNeedsLoginAndCall): void {
        needsLoginAndCall(error.message, credentials?.credentials.userName || undefined);
    }
}
